import {MicromorgiIcon} from '@/assets/icons/icons'
import {Avatar} from '@/components/ui/avatar/Avatar'
import {SupporterTypeV3} from '@/features/goal/types'
import {ROUTE_SUPPORTER_GUEST_PAGE} from '@/utilities/constants/routeNames'
import {generatePath, useNavigate} from 'react-router'
import {StyledAmount, StyledAvatar, StyledName, StyledSupporterCardRoot} from './style'

export const SupporterCard = ({supporter}: {supporter: SupporterTypeV3}) => {
    const navigate = useNavigate()

    const redirectToSupporterProfile = () => {
        navigate(generatePath(ROUTE_SUPPORTER_GUEST_PAGE, {leaderId: `${supporter.id}`}))
    }

    return (
        <StyledSupporterCardRoot>
            <StyledAvatar onClick={redirectToSupporterProfile}>
                <Avatar height={50} width={50} imageUrl={supporter?.avatar?.url} name={supporter?.fullName} />
            </StyledAvatar>
            <StyledName>{supporter?.fullName}</StyledName>
            <StyledAmount>
                {supporter?.typeAttributes?.leaderDonationsAmount}
                <MicromorgiIcon />
            </StyledAmount>
        </StyledSupporterCardRoot>
    )
}
